import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../consts/routes';
import { useAdminCardDecksServers } from '@olagg/api-hooks';
import ServerForm from './Form';
import { CreateCardDeckServerData } from '@olagg/db-types';
import { Center, VStack, Heading } from '@chakra-ui/react';

export const CreateServer = () => {
  const navigate = useNavigate();
  const { deck_id } = useParams();

  if (!deck_id) return null;
  
  const { createServer } = useAdminCardDecksServers(deck_id);

  const handleSubmit = async (data: CreateCardDeckServerData) => {
    await createServer(data);
    navigate(generatePath(ROUTES.CARD_DECKS.servers.all, { deck_id  }));
  };

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>
          Crear Servidor de Discord
        </Heading>
        <ServerForm onSubmit={handleSubmit} />
      </VStack>
    </Center>
  );
};
